import { useContext, useEffect, useState } from 'react'
import { DContext } from '../../../context/Datacontext'
import { fetchMyCourses } from '../../../services/students/courses/fetchMyCourses'
import Loading from '../../Loading'
import { BiRupee } from 'react-icons/bi'
import {
  FiAward,
  FiBookOpen,
  FiCheckCircle,
  FiClock,
  FiXCircle
} from 'react-icons/fi'

function UserCourses() {
  const { BeURL } = useContext(DContext)
  const [orders, setOrders] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    const loadOrders = async () => {
      setLoading(true)
      const result = await fetchMyCourses({ BeURL })
      if (result?.success) {
        setOrders(result.orders || [])
        setError(null)
      } else {
        setOrders([])
        setError(result?.message || 'Failed to fetch courses')
      }
      setLoading(false)
    }

    if (BeURL) loadOrders()
  }, [BeURL])

  const formatPrice = (price) => {
    const valid = typeof price === 'number' && price >= 0 ? price : 0
    return Math.round(valid).toLocaleString('en-IN')
  }

  const getStatusMeta = (order) => {
    if (order?.accessGranted) {
      return { label: 'Access Granted', icon: FiCheckCircle, className: 'bg-emerald-50 text-emerald-700 border-emerald-200' }
    }
    if (order?.orderStatus === 'cancelled') {
      return { label: 'Cancelled', icon: FiXCircle, className: 'bg-rose-50 text-rose-700 border-rose-200' }
    }
    return { label: 'Awaiting Approval', icon: FiClock, className: 'bg-amber-50 text-amber-700 border-amber-200' }
  }

  const handleCourseClick = (courseId) => {
    if (courseId) {
      window.location.href = `/learner/courses/${courseId}`
    }
  }

  if (!BeURL || loading) return <Loading />

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-blue-50/40 p-4 sm:p-6 font-['Space_Grotesk']">
      <div className="max-w-6xl mx-auto">
        <div className="mb-6 rounded-2xl bg-white border border-slate-200 p-6 shadow-sm animate-in fade-in">
          <div className="flex items-center gap-3 text-2xl sm:text-3xl font-semibold text-slate-900">
            <FiAward className="text-primary-600" />
            My Courses
          </div>
          <p className="text-sm text-slate-500 mt-2">
            Only the courses you have ordered appear here. Access is granted manually by admin.
          </p>
        </div>

        {error && (
          <div className="mb-6 rounded-xl border border-rose-200 bg-rose-50 px-4 py-3 text-sm text-rose-800">
            {error}
          </div>
        )}

        {orders.length === 0 ? (
          <div className="bg-white rounded-2xl border border-slate-200 p-10 text-center shadow-sm">
            <div className="w-16 h-16 rounded-2xl bg-slate-100 flex items-center justify-center mx-auto mb-4">
              <FiBookOpen className="text-slate-500" size={28} />
            </div>
            <h3 className="text-lg font-semibold text-slate-800">No courses yet</h3>
            <p className="text-sm text-slate-500 mt-2">Create an order from your cart to start learning.</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
            {orders.map((order, index) => {
              const status = getStatusMeta(order)
              const StatusIcon = status.icon

              return (
                <div
                  key={order._id || index}
                  className="bg-white cursor-pointer rounded-2xl border border-slate-200 shadow-sm hover:shadow-lg transition-all duration-300 p-5 flex flex-col animate-slide-in-bottom"
                  style={{ animationDelay: `${index * 60}ms` }}
                  onClick={() => handleCourseClick(order?.course?.id || "")}
                >
                  <div className="flex items-start justify-between gap-3">
                    <div>
                      <h4 className="text-lg font-semibold text-slate-900 line-clamp-2">
                        {order?.course?.title || 'Untitled Course'}
                      </h4>
                      <div className={`mt-2 inline-flex items-center gap-2 px-3 py-1 rounded-full border text-xs ${status.className}`}>
                        <StatusIcon size={14} />
                        {status.label}
                      </div>
                    </div>
                    <div className="text-right">
                      <div className="text-xs text-slate-400">Order</div>
                      <div className="text-sm font-semibold text-slate-700">{order?.orderId || 'N/A'}</div>
                    </div>
                  </div>

                  <div className="mt-5 flex items-center justify-between">
                    <div className="text-sm text-slate-500">Total Paid</div>
                    <div className="text-xl font-semibold text-primary-600 flex items-center">
                      <BiRupee />
                      {formatPrice(order?.pricing?.totalAmount)}
                    </div>
                  </div>
                </div>
              )
            })}
          </div>
        )}
      </div>
    </div>
  )
}

export default UserCourses